"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolatilityModel = exports.MoneynessType = exports.InputVolatilityType = exports.TimeStampSelectionType = exports.PriceSide = exports.Outputs = exports.LayoutFormat = exports.AxisUnit = void 0;
const surfaces_1 = require("./surfaces");
Object.defineProperty(exports, "AxisUnit", { enumerable: true, get: function () { return surfaces_1.AxisUnit; } });
Object.defineProperty(exports, "LayoutFormat", { enumerable: true, get: function () { return surfaces_1.LayoutFormat; } });
Object.defineProperty(exports, "Outputs", { enumerable: true, get: function () { return surfaces_1.Outputs; } });
Object.defineProperty(exports, "PriceSide", { enumerable: true, get: function () { return surfaces_1.PriceSide; } });
Object.defineProperty(exports, "TimeStampSelectionType", { enumerable: true, get: function () { return surfaces_1.TimeStampSelectionType; } });
__exportStar(require("./surfaces"), exports);
var InputVolatilityType;
(function (InputVolatilityType) {
    InputVolatilityType["Implied"] = "Implied";
    InputVolatilityType["Settle"] = "Settle";
    InputVolatilityType["Quoted"] = "Quoted";
})(InputVolatilityType || (exports.InputVolatilityType = InputVolatilityType = {}));
var MoneynessType;
(function (MoneynessType) {
    MoneynessType["Spot"] = "Spot";
    MoneynessType["Fwd"] = "Fwd";
    MoneynessType["Sigma"] = "Sigma";
})(MoneynessType || (exports.MoneynessType = MoneynessType = {}));
var VolatilityModel;
(function (VolatilityModel) {
    VolatilityModel["SVI"] = "SVI";
    VolatilityModel["SSVI"] = "SSVI";
})(VolatilityModel || (exports.VolatilityModel = VolatilityModel = {}));
